/*
 * ohp-ret.js — Retention Home behaviors.
 * ------------------------------------------------------------------
 * Design spec: BrandTruth RetentionHome.jsx + retention-home-notes.md.
 * Loaded by layout/theme.retention.liquid (retention chrome only).
 *
 * Handles:
 *   1. Reorder add-to-cart / add-all — POST variant IDs to the native Cart AJAX API
 *      and re-render + open Dawn's cart drawer.
 *   2. Subscribe & Save waitlist — LIVE Klaviyo client-subscribe POST (list WrGhV2,
 *      company HzVMMY, property waitlist_subscribe_save=true), optimistic success.
 *   3. Refer-a-friend / Redeem — open the Stamped Rewards Launcher (graceful fallback).
 *   4. Points balance — fill [data-opti-points-total] client-side (best-effort; the
 *      server-side render with the private Stamped key is preferred, see notes §1).
 *   5. "Notify me" on out-of-stock reorder rows — send to the product page.
 */
(function () {
  'use strict';

  var routes = window.routes || {};

  /* =================================================================
   * 1. Reorder — native Ajax cart
   * ================================================================= */
  function addItems(items, trigger) {
    var cartDrawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      body.sections = cartDrawer.getSectionsToRender().map(function (sec) { return sec.id; });
      body.sections_url = window.location.pathname;
    }
    var label;
    if (trigger) { label = trigger.textContent; trigger.setAttribute('disabled', ''); trigger.textContent = 'Adding...'; }

    return fetch(routes.cart_add_url || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.status) { // Shopify returns status/description on error
          if (window.console) console.warn('[OHP ret] Add to cart failed:', data.description || data.message);
          return;
        }
        if (cartDrawer && data && data.sections) {
          cartDrawer.renderContents(data);
        } else if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          window.location.href = routes.cart_url || '/cart';
        }
      })
      .catch(function (e) { if (window.console) console.warn('[OHP ret] Add to cart error:', e); })
      .then(function () {
        if (trigger) { trigger.removeAttribute('disabled'); trigger.textContent = label; }
      });
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-ohp-cart-add]');
    if (addBtn) {
      e.preventDefault();
      var id = addBtn.getAttribute('data-ohp-cart-add');
      var qty = parseInt(addBtn.getAttribute('data-ohp-cart-qty'), 10);
      if (id) addItems([{ id: Number(id), quantity: qty > 0 ? qty : 1 }], addBtn);
      return;
    }

    var addAllBtn = e.target.closest('[data-ohp-cart-add-all]');
    if (addAllBtn) {
      e.preventDefault();
      // Each entry is "variantId:quantity" so a prior multi-unit order reorders at its
      // original quantity rather than a single unit.
      var raw = addAllBtn.getAttribute('data-ohp-cart-add-all') || '';
      var items = raw.split(',').filter(Boolean).map(function (pair) {
        var parts = pair.split(':');
        var pairQty = parseInt(parts[1], 10);
        return { id: Number(parts[0]), quantity: pairQty > 0 ? pairQty : 1 };
      });
      if (items.length) addItems(items, addAllBtn);
      return;
    }

    var notifyBtn = e.target.closest('[data-ohp-notify]');
    if (notifyBtn) {
      e.preventDefault();
      var handle = notifyBtn.getAttribute('data-ohp-notify');
      // Handle is a Shopify product handle; validate its shape and encode it so the
      // DOM-sourced value can never break out of the relative /products/ path.
      if (handle && /^[a-z0-9_-]+$/i.test(handle)) {
        window.location.href = '/products/' + encodeURIComponent(handle);
      }
      return;
    }

    var launcher = e.target.closest('[data-ohp-rewards-launcher]');
    if (launcher) {
      e.preventDefault();
      openRewardsLauncher();
      return;
    }
  });

  /* =================================================================
   * 2. Subscribe & Save waitlist — live Klaviyo (fire-and-forget)
   * ================================================================= */
  function postWaitlist(email) {
    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=HzVMMY', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email, properties: { waitlist_subscribe_save: true } }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: 'WrGhV2' } } }
          }
        })
      }).catch(function () {});
    } catch (e) { /* ignore */ }
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-ohp-waitlist-form]'), function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('[name="email"]');
      var email = input ? input.value.trim() : '';
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        if (input && input.reportValidity) input.reportValidity();
        return;
      }
      // Optimistic: show confirmation immediately, then fire the POST.
      var scope = form.parentElement || document;
      var success = scope.querySelector('[data-ohp-waitlist-success]');
      form.hidden = true;
      if (success) success.hidden = false;
      postWaitlist(email);
    });
  });

  /* =================================================================
   * 3. Stamped Rewards Launcher (redeem + refer a friend)
   * ================================================================= */
  function openRewardsLauncher() {
    try {
      if (window.StampedFn && typeof window.StampedFn.openRewards === 'function') {
        window.StampedFn.openRewards();
        return;
      }
    } catch (e) { /* ignore */ }
    var tab = document.querySelector('.stamped-launcher, #stamped-rewards-launcher, [class*="stamped-launcher"]');
    if (tab) { tab.click(); return; }
    if (window.console) {
      console.info('[Stamped] Rewards launcher not present — enable the "Rewards Launcher" app embed on the live store.');
    }
  }

  /* =================================================================
   * 4. Points balance — client-side fill (best-effort)
   * Server-side render with the PRIVATE Stamped key is preferred (notes §1); until then
   * the nodes show a dash. If Stamped exposes the balance on the storefront, use it.
   * ================================================================= */
  function fillPoints() {
    var nodes = document.querySelectorAll('[data-opti-points-total]');
    if (!nodes.length) return;
    try {
      if (window.StampedFn && typeof window.StampedFn.getCustomerPoints === 'function') {
        window.StampedFn.getCustomerPoints(function (points) {
          if (points === null || points === undefined) return;
          Array.prototype.forEach.call(nodes, function (n) { n.textContent = points; });
        });
      }
    } catch (e) { /* leave the placeholder */ }
  }
  fillPoints();
})();
